const PhotographyHome = () => {
    return (
        <>
        We are here for the real, spontaneous moments that bring out true emotions.
        </>
    )
}

export default PhotographyHome;